export const useStyles = (theme) => ({
  gridRoot: {
    padding: 10,
    display: "flex",
    justifyContent: "center",
  },
  avatarStyle: {
    width: 100,
    height: 100,
    backgroundColor: "#eee",
  },
  textStyle: {
    fontSize: 20,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },

  buttonStyle: {
    background: "#0a1f3a !important",
    outlineColor: "#0a1f3a !important",
    color: "#ffffff",
    fontSize: 18,
    borderRadius: 20,
    textTransform: "none",
    marginRight: 10,
    "&:hover": {
      backgroundColor: "#eee !important",
      borderColor: "#0a1f3a !important",
      color: "#181818",
    },
  },
});
